import MeetUp from './MeetUp';

export default MeetUp;
